export default {
  slug: "innovation-hub",
  code: "IH",
  label: "Innovation Hub",
  logoFamily: "ih",
};
